import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
	fetchContestResultsRequest,
	fetchContestsRequest,
	fetchPlayersRequest,
	fetchSquadsRequest,
} from "modules/actions";
import {getActiveContest, isLoggedIn} from "modules/selectors";
import {AdobeAnalyticService} from "modules/utils/Services/AdobeAnalyticService";
import {useLocation} from "react-router-dom";

interface IProps {
	children: React.ReactElement;
}
export const HOCMain: React.FC<IProps> = ({children}) => {
	const dispatch = useDispatch();
	const contest = useSelector(getActiveContest);
	const isAuth = useSelector(isLoggedIn);
	const location = useLocation();

	useEffect(() => {
		dispatch(fetchContestsRequest());
		dispatch(fetchPlayersRequest());
		dispatch(fetchSquadsRequest());
	}, [dispatch]);

	useEffect(() => {
		if (location.search === "") {
			return;
		}

		AdobeAnalyticService.getRSIDFromUrlAndMoveToCookies(location.search);
	}, [location.search]);

	useEffect(() => {
		if (contest && isAuth) {
			dispatch(fetchContestResultsRequest(contest.id));
		}
	}, [contest, dispatch, isAuth]);

	return <React.Fragment>{children}</React.Fragment>;
};
